export function isDownloadLimitReached(downloadCount: number) {
    return downloadCount >= 3;
}
